import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';

class Sidebar extends Component {
  static contextType = AppContext;

  render() {
    const contextValue = this.context || {};
    const state = contextValue.state || {};
    const owner = state.owner || null;

    let menuItems = [
      { title: 'דף הבית', path: '/', icon: '🏠' },
      { title: 'כל המוצרים', path: '/all-products', icon: '📦' },
      { title: 'המוצרים שלי', path: '/my-products', icon: '🛒' },
      { title: 'העסקים שלי', path: '/my-businesses', icon: '🏪' },
      { title: 'המבצעים שלי', path: '/my-offers', icon: '🏷️' },
      { title: 'רשימת עדכונים', path: '/updates', icon: '🔔' },
      { title: 'ניתוח ודוחות', path: '/reports', icon: '📊' },
      { title: 'Test Chat', path: '/test-chat', icon: '💬' },
    ];
const blockedPhones = [
  '+972510009876',
  '+972502110420',
];
    if (!owner || !blockedPhones.includes(owner.phone_number)) {
      menuItems = menuItems.filter((item) => item.path !== '/test-chat');
    }

    return (
      <aside className="app-sidebar">
        <div className="sidebar-logo">MBVIP</div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                isActive ? 'sidebar-link active' : 'sidebar-link'
              }
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              <span className="sidebar-link-text">{item.title}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    );
  }
}

export default Sidebar;